module.exports = __webpack_public_path__ + "static/media/light_digitalMarketing_bg.c5a46967.jpg";